exports.onClientEntry = () => {
  return new Promise((resolve, reject) => {
    window.__polyfillio__ = () => {
      resolve()
    }

    const features = []

    if (!('es6' in window)) {
      features.push('es6')
    }

    if (!('fetch' in window)) {
      features.push('fetch')
    }

    if (!('Array.prototype.includes' in window)) {
      features.push('Array.prototype.includes')
    }

    if (!('Array.prototype.unique' in window)) {
      features.push('Array.prototype.unique')
    }

    if (!('Date.now' in window)) {
      features.push('Date.now')
    }

    if (typeof Set === 'undefined') {
      features.push('Set')
    }

    if (typeof Map === 'undefined') {
      features.push('Map')
    }

    if (features.length) {
      const s = document.createElement('script')
      s.src = `https://cdn.polyfill.io/v3/polyfill.min.js?features=${features.join(
        ','
      )}&flags=always,gated&callback=__polyfillio__`
      s.async = true
      s.onerror = reject
      document.head.appendChild(s)
    } else {
      resolve()
    }
  })
}
